module.exports = { "default": require("core-js/library/fn/math/sinh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/sinh.js
// module id = 1402
// module chunks = 2